import React from 'react';

import { images } from '../../constants';

const SubHeading = ({title}) => (
  <div style={{ marginBottom : '1rem', color: 'inherit' }}>
    <p className="p__opensans" style={{ color: 'inherit', fontFamily: 'var(--font-ui)', fontSize: '.72rem', fontWeight: 700, letterSpacing: '.16em', textTransform: 'uppercase' }}>{title}</p>
    <img src={images.spoon} alt="spoon" style={{width: '55px'}} />
  </div>
);

export default SubHeading;
